import { ListItemText, Typography } from '@mui/material';

const StageTitle = ({ item }) => {
  return (
    <ListItemText
      primary={<Typography variant='h5'>{item?.title}</Typography>}
    />
  );
};

export default StageTitle;
